import { queryOptions, useMutation } from '@tanstack/react-query';
import { api, failure, rememberCsrfToken } from './api.js';
/**
 * The signed-in person, from the BFF. `null` means not signed in; the session cookie is
 * HttpOnly, so this request is the only way the app learns about it.
 */
export const meQuery = queryOptions({
    queryKey: ['me'],
    queryFn: async () => {
        const { data, error, response } = await api.GET('/api/v1/me');
        if (response.status === 401)
            return null;
        if (!data)
            throw failure('getMe', error, response.status);
        rememberCsrfToken(data.csrfToken);
        return data;
    },
    staleTime: 60_000,
    retry: false,
});
/** Path to come back to after login, without the failure marker of a previous attempt. */
export function currentPath() {
    const url = new URL(window.location.href);
    url.searchParams.delete('auth');
    return `${url.pathname}${url.search}${url.hash}`;
}
/**
 * Starts the login at Keycloak; afterwards the BFF brings the person back to `returnTo`. With
 * an intent, the running session is confirmed with a fresh second factor, or the person adds a
 * passkey or an authenticator app, or changes the password, name or address at Keycloak.
 */
export function startSignIn(returnTo, intent) {
    const query = new URLSearchParams({ returnTo });
    if (typeof intent === 'object')
        query.set('remove', intent.remove);
    else if (intent === 'step-up')
        query.set('stepUp', '1');
    else if (intent === 'signup')
        query.set('signup', '1');
    else if (intent)
        query.set('setup', intent);
    window.location.assign(`/auth/login?${query.toString()}`);
}
export function useSignOut() {
    return useMutation({
        mutationFn: async () => {
            const { data, error, response } = await api.POST('/auth/logout');
            if (!data)
                throw failure('logout', error, response.status);
            return data;
        },
        // Ends single sign-on at Keycloak too, which then returns to the app's start page.
        onSuccess: ({ endSessionUrl }) => {
            window.location.assign(endSessionUrl ?? '/');
        },
    });
}
//# sourceMappingURL=session.js.map